import fetchManager from '@utils/fetchManager'
import { urlQueryData, getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");

export default {
  getSearchSuplier: async (querys) => {
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/pdd/suppliers/list`, querys)
    const response = await fetchManager(url)
    return response
  },
  updataSupplier: async (data) => {
    var form = new FormData();
    form.append("content", JSON.stringify(data));


    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/pdd/suppliers`, {
        method: 'PATCH',
        "mimeType": "multipart/form-data",
        "contentType": false,
        data: form,
      })
    return response
  },
}